import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X, ArrowRight } from "lucide-react";
import { useLanguage } from "../contexts/LanguageContext";

const ITEMS = {
    tr: [
        "Yeni oranlar — komisyon piyasanın altında, White-hat %2.5'ten %1'e iniyor",
        "Anında bonus — $50K+ yüklemede bakiyene +%8 kredi hemen eklenir",
        "Güncelleme — Taboola & Outbrain ajans hesapları artık aktif",
    ],
    en: [
        "New rates — fees below market, white-hat drops from 2.5% to 1%",
        "Instant bonus — top up $50K+ and get +8% credited to your balance now",
        "Update — Taboola & Outbrain agency accounts are now live",
    ],
    es: [
        "Nuevas tarifas — comisiones por debajo del mercado, white-hat del 2.5% al 1%",
        "Bono instantáneo — recarga $50K+ y recibe +8% en tu saldo al momento",
        "Novedad — cuentas de agencia de Taboola y Outbrain ya disponibles",
    ],
    pt: [
        "Novas taxas — comissões abaixo do mercado, white-hat de 2.5% para 1%",
        "Bônus instantâneo — recarregue $50K+ e ganhe +8% no saldo na hora",
        "Novidade — contas de agência Taboola e Outbrain agora ativas",
    ],
    ru: [
        "Новые ставки — комиссии ниже рынка, white-hat с 2.5% до 1%",
        "Мгновенный бонус — пополни $50K+ и получи +8% на баланс сразу",
        "Обновление — агентские аккаунты Taboola и Outbrain уже доступны",
    ],
};

const CTA = { tr: "Detaylar", en: "See details", es: "Ver detalles", pt: "Ver detalhes", ru: "Подробнее" };

export default function CampaignBar() {
    const { language } = useLanguage();
    const items = ITEMS[language] || ITEMS.en;
    const [i, setI] = useState(0);
    const [hidden, setHidden] = useState(false);

    useEffect(() => {
        const id = setInterval(() => setI((v) => (v + 1) % items.length), 4600);
        return () => clearInterval(id);
    }, [items.length]);

    if (hidden) return null;

    return (
        <div
            data-testid="campaign-bar"
            className="relative border-b border-white/[0.08]"
            style={{ background: "hsl(30 8% 8%)" }}
        >
            <div className="container-skala h-9 flex items-center justify-center gap-3 text-center">
                <span className="w-1.5 h-1.5 rounded-full bg-highlight shrink-0" />
                <Link to="/#bonus" key={i} className="reveal-up text-[12px] md:text-[12.5px] font-medium text-foreground/80 hover:text-foreground truncate">
                    {items[i]}
                    <span className="ml-2 inline-flex items-center gap-1 text-highlight font-semibold">
                        {CTA[language] || CTA.en}
                        <ArrowRight className="w-3 h-3" />
                    </span>
                </Link>
                <button aria-label="dismiss" onClick={() => setHidden(true)} className="absolute right-4 text-foreground/40 hover:text-foreground">
                    <X className="w-3.5 h-3.5" />
                </button>
            </div>
        </div>
    );
}
